import { useEffect, useState, type AnchorHTMLAttributes } from 'react'
import { APP_URL } from '@/lib/public-trpc'
import { appSignupUrl } from '@/lib/attribution'

/**
 * A link to sign up on fuguelab.app that carries how this visitor found us
 * (lib/attribution.ts). Use it for every fuguelab.com → app signup link.
 *
 * The prerendered HTML holds the plain sign-up URL; the attributed one is set
 * after mount, because hydration keeps the server's attribute value and the
 * session's first touch only exists in the browser.
 */
export function AppSignupLink({ children, ...props }: Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'>) {
  const [href, setHref] = useState(`${APP_URL}/auth?mode=signup`)
  useEffect(() => setHref(appSignupUrl()), [])
  return (
    <a {...props} href={href}>
      {children}
    </a>
  )
}
